import lazy from "../components/lazy/lazy"; lazy();

import animations from '../components/animations/animations'; animations();

import subscrSect from '../components/subscr-sect/subscr-sect'; subscrSect();
import superSect from '../components/super-sect/super-sect'; superSect();

import scrollTo from '../components/scroll-to/scroll-to'; scrollTo();

import gallery from '../components/gallery/gallery'; gallery();

import '../components/slider/slider';
import '../components/header/header';

BX.ready(function() {
	var buttons = document.querySelectorAll('.js-section-add-to-cart[data-product-id]');

	if (!!buttons) {
		buttons.forEach(function (el) {
			el.addEventListener('click', function (ev) {
				var productId = Number(ev.target.dataset.productId);
				if (productId > 0) {
					BX.onCustomEvent('OnAddToCart', [productId]);
				}
			})
		})
	}

	var qpButtons = document.querySelectorAll('.js-question-price[data-url]');

	if (!!qpButtons) {
		qpButtons.forEach(function (el) {
			el.addEventListener('click', function (ev) {
				var url = ev.target.dataset.url;
				if (url) {
					BX.onCustomEvent('OnQuestionPrice', [url]);
				}
			})
		})
	}
})